import axios from 'axios';
import authHeader from "@/service/auth-header";

class FilterComponentService {

    async getFilterComponentsForFilter(filterId) {
        return await axios.get(`/api/applications/si/filtercomponent/${filterId}`,{ headers: authHeader() })
    }

    async createFilterComponent(filterId, data) {
        console.log('[FilterComponentService][createFilterComponent] data = ', data);
        return await axios.post(`/api/applications/si/filtercomponent/${filterId}`, data,{ headers: authHeader() });
    }

    async updateFilterComponent(id, data) {
        return await axios.put(`/api/applications/si/filtercomponent/${id}`, data,{ headers: authHeader() });
    }

    async deleteFilterComponent(id) {
        return await axios.delete(`/api/applications/si/filtercomponent/${id}`,{ headers: authHeader() })
    }

}

export default new FilterComponentService();
